import mixpanelBrowser from 'mixpanel-browser'

const token = process.env.REACT_APP_MIXPANEL_TOKEN

// Without a token (local dev, or an environment not yet configured) every call is a no-op.
if (token) {
  mixpanelBrowser.init(token, {
    debug: process.env.REACT_APP_DEVELOPMENT_MODE === 'true',
    track_pageview: false,
    persistence: 'localStorage',
  })
  // Staging and production share one Mixpanel project; this tells their events apart.
  mixpanelBrowser.register({ environment: process.env.REACT_APP_STAGE })
}

export const mixpanel = {
  enabled: !!token,
  track(event: string, properties: Record<string, unknown>): void {
    if (token) mixpanelBrowser.track(event, properties)
  },
  identify(userId: string, traits: Record<string, unknown>): void {
    if (!token) return
    mixpanelBrowser.identify(userId)
    mixpanelBrowser.people.set(traits)
  },
  reset(): void {
    if (token) mixpanelBrowser.reset()
  },
}
